export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M15.15 2.51c.37.06.67.32.79.66.04.1.06.21.06.33v6c0 .27-.22.5-.5.5s-.5-.23-.5-.5V3.88L8.3 8.9c-.09.07-.19.1-.3.1-.11 0-.21-.03-.3-.1L1 3.88v8.62h6.55c.27 0 .5.22.5.5s-.23.5-.5.5H1c-.55 0-1-.45-1-1v-9a1.042 1.042 0 01.85-1l14.3.01zM2.17 3.5L8 7.88l5.83-4.38H2.17z\" clip-rule=\"evenodd\"/><path d=\"M13.9 10.69c-.2-.2-.51-.2-.71 0h-.01c-.2.2-.2.51 0 .71l1.1 1.1H9.96c-.28 0-.5.22-.5.5s.22.5.5.5h4.33l-1.11 1.11c-.2.2-.2.51 0 .71.2.2.51.2.71 0l1.96-1.96c.1-.1.15-.23.15-.36 0-.15-.06-.29-.17-.38l-1.93-1.93z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};